/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from '@mui/material';
import { logger } from '@musedrops/shared';
import type { VoiceProfile } from '@musedrops/shared';
import { voiceProfileApi } from '../../services/voiceProfileApi';

interface VoiceProfileSelectorProps {
  value: string;
  onChange: (profileKey: string) => void;
  label?: string;
  required?: boolean;
}

export const VoiceProfileSelector: React.FC<VoiceProfileSelectorProps> = ({
  value,
  onChange,
  label = 'Voice Profile',
  required = false,
}) => {
  const [voiceProfiles, setVoiceProfiles] = useState<VoiceProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadVoiceProfiles = async () => {
      try {
        setLoading(true);
        const profiles = await voiceProfileApi.getVoiceProfiles();
        setVoiceProfiles(profiles);
        setError('');
      } catch (err) {
        setError(
          err instanceof Error ? err.message : 'Failed to load voice profiles'
        );
        logger.error('Failed to load voice profiles', { error: err });
      } finally {
        setLoading(false);
      }
    };

    loadVoiceProfiles();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {error && (
        <Alert severity="error" onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <FormControl fullWidth required={required}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          onChange={e => onChange(e.target.value)}
          label={label}
          disabled={loading}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {voiceProfiles.map(profile => (
            <MenuItem key={profile.key} value={profile.key}>
              {profile.key}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
